export default __webpack_public_path__ + "static/media/EA909430.30d9883a.jpg";